import React, { Dispatch, SetStateAction } from "react"
import "twin.macro"
import { QuestionState } from "../../graphql/generated/graphql"
import { QuestionProps } from "../../pages/q/[id]"
import { never } from "../../utils"
import { QuestionAnswered } from "./state/answered"
import { QuestionFlagged } from "./state/flagged"
import { QuestionExpired } from "./state/expired"
import { QuestionOpen } from "./state/open"
import { QuestionPublishing } from "./state/publishing"

export interface RecorderProps {
  showRecorder: boolean
  setShowRecorder: Dispatch<SetStateAction<boolean>>
  setIsDark: Dispatch<SetStateAction<boolean>>
  isDark: boolean
}

export const downloadImage = (name: string, image: string) => {
  const link = document.createElement("a")
  link.download = `${name}.png`
  link.href = image
  link.click()
}
const QuestionComponent = (props: QuestionProps) => {
  const { question } = props
  const { state } = question

  const questionView = () => {
    switch (state) {
      case QuestionState.Open:
        return <QuestionOpen {...props} />
      case QuestionState.AnswerPublishing:
        return <QuestionPublishing {...props} />
      case QuestionState.Answered:
        return <QuestionAnswered {...props} />
      case QuestionState.Flagged:
      case QuestionState.Declined:
        return <QuestionFlagged />
      case QuestionState.Expired:
        return <QuestionExpired {...props} />
      case QuestionState.Flagged:
        return <QuestionFlagged />
      default:
        return never(state)
    }
  }

  return <div data-testid={`question-${state.toLowerCase()}`}>{questionView()}</div>
}
export default QuestionComponent
